import './App.css';
import React from "react";
import {Link} from "react-router-dom";

function Home() {
  return (
    <div>
      <div className="alert alert-primary m-2 mb-2" role="alert">
        <h1>Emergency Travel Arrangements </h1>
      </div>
      <div className="alert alert-secondary m-2" role="alert">

        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
          magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
          consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
          est
          laborum</p>
      </div>
      <Link to="/signin" class="btn btn-primary">CONTINUE</Link>
    </div>
  );
}

export default Home;
